module.exports = __webpack_public_path__ + "img/chips2.87846b05.png";